import React from 'react';
import Footer from './Footer';
import './App.css';

const About = () => {
  return (
    <div className="home-container">
      {/* ── About Hero ── */}
      <section className="hero-section about-hero">
        <div className="hero-left">
          <div className="hero-tag">Engineering-First CPQ</div>
          <h1 className="hero-title">
            About <span>IndustriQuote</span>
          </h1>
          <p className="hero-subtitle" style={{ maxWidth: '600px' }}>
            IndustriQuote is a platform built for industrial manufacturers who need precision, speed, and scalability in their quoting process.
          </p>
          <p className="hero-subtitle" style={{ maxWidth: '600px', marginTop: '-1rem' }}>
            We design and develop parametric configurators tailored to complex product lines, enabling engineering and sales teams to generate accurate specifications, pricing, and documentation in real time.
          </p>
        </div>
      </section>

      {/* ── Content Sections ── */}
      <section className="about-content-section">
        <div className="about-grid">
          
          {/* What We Do */}
          <div className="about-card">
            <h2>What We Do</h2>
            <p>IndustriQuote specializes in custom-built configurators for:</p>
            <ul>
              <li>Industrial sensors and instrumentation</li>
              <li>Mechanical components and assemblies</li>
              <li>Engineered-to-order systems</li>
            </ul>
            <p>Each solution is developed around your exact product logic, constraints, and workflows. From dimensional rules to pricing structures, every parameter is modeled to reflect real-world engineering requirements.</p>
          </div>

          {/* Why IndustriQuote */}
          <div className="about-card highlight-card">
            <h2>Why IndustriQuote</h2>
            <p>Traditional quoting processes rely heavily on spreadsheets, tribal knowledge, and manual validation. This slows down response times and introduces risk.</p>
            <p>IndustriQuote replaces that with:</p>
            <ul>
              <li>Deterministic configuration logic</li>
              <li>Real-time pricing and validation</li>
              <li>Automated model number generation</li>
              <li>Integrated engineering outputs (2D/3D)</li>
            </ul>
            <p>The result is faster quotes, fewer errors, and a more scalable sales process.</p>
          </div>

          {/* How We Work */}
          <div className="about-card full-width">
            <h2>How We Work</h2>
            <p>We collaborate directly with manufacturers to translate engineering knowledge into structured, parametric systems.</p>
            <div className="process-steps">
              <div className="step"><span>1</span> Product & Rules Modeling</div>
              <div className="step"><span>2</span> Architecture Design</div>
              <div className="step"><span>3</span> UI & Workflow Development</div>
              <div className="step"><span>4</span> System Integration</div>
              <div className="step"><span>5</span> Refinement & Expansion</div>
            </div>
            <p style={{ marginTop: '1.5rem', fontStyle: 'italic', color: 'var(--text-muted)' }}>
              Every configurator is purpose-built. There are no templates or shortcuts that compromise accuracy.
            </p>
          </div>

          {/* Who We Serve */}
          <div className="about-card">
            <h2>Who We Serve</h2>
            <p>IndustriQuote is built for:</p>
            <ul>
              <li><strong>Engineering teams</strong> who need precise configuration control</li>
              <li><strong>Sales teams</strong> who need speed without sacrificing accuracy</li>
              <li><strong>Procurement teams</strong> who require reliable specifications</li>
            </ul>
            <p>If your products are complex, customizable, or engineered-to-order, IndustriQuote is designed for your workflow.</p>
          </div>

          {/* Mission & Contact */}
          <div className="about-card contact-card">
            <h2>Our Mission</h2>
            <p>To modernize industrial sales and engineering processes by turning complex product logic into fast, reliable, and scalable digital systems.</p>
            
            <div className="about-contact-info">
              <h3>Contact Us</h3>
              <div className="contact-row-item">
                <strong>Sales:</strong> <a href="tel:7732073269">(773) 207-3269</a>
              </div>
              <div className="contact-row-item">
                <strong>General:</strong> <a href="mailto:info@IndustriQuote.com">info@IndustriQuote.com</a>
              </div>
            </div>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
